import './TextEditorWarningLabel.scss';

function TextEditorWarningLabel({
  show,
  message,
} = {
  show: false,
  message: '',
}) {
  if (!show) {
    return null;
  }
  return (
    <div className='text-editor-warning-label'>
      {message}
    </div>
  );
}

export default TextEditorWarningLabel;
